module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-loader",
    class: {
      '-hidden': !_vm.showLoading
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "lds-text"
  }, [_vm._v(_vm._s(_vm.loadingMessage) + "...")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lds-ring"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4679cadb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/main/GlobalLoader.vue
// module id = 539
// module chunks = 2